import { render } from "@/components/pages/realWorldData/realWorldDataISA/RealWorldDataISA.html?vue&type=template&id=5696ba7d&external"
import script from "@/components/pages/realWorldData/realWorldDataISA/RealWorldDataISA.js?vue&type=script&lang=js&external"
export * from "@/components/pages/realWorldData/realWorldDataISA/RealWorldDataISA.js?vue&type=script&lang=js&external"

import "@/components/pages/realWorldData/realWorldDataISA/RealWorldDataISA.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__